import type { Cropping } from '~/types/AppData/PartialImageTypes';

/**
 * Extracts cropping information from a Cloudinary image URL.
 * @param src
 */
export const getImageCroppingObject = (src: string) => {
  const cropMatch = src.match(/c_crop,([^/]+)/);
  if (!cropMatch) return;

  const params = cropMatch[1].split(',');
  const result: Cropping = { width: 0, height: 0, x: 0, y: 0 };

  const keyMap: Record<string, keyof Cropping> = {
    w: 'width',
    h: 'height',
    x: 'x',
    y: 'y',
  };

  for (const param of params) {
    const [key, value] = param.split('_');
    if (key in keyMap && !isNaN(Number(value))) {
      const mappedKey = keyMap[key as keyof typeof keyMap];
      result[mappedKey as keyof Cropping] = Number(value);
    }
  }

  return result;
};
